// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"4f5a9742","702":"4f5a9742","898":"4f5a9742"}[chunkId] + ".chunk.css";
};